import { render, staticRenderFns } from "./SubscriptionsHistory.vue?vue&type=template&id=d88217c4&scoped=true&"
import script from "./SubscriptionsHistory.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsHistory.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsHistory.vue?vue&type=style&index=0&id=d88217c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88217c4",
  null
  
)

export default component.exports